import React, { useEffect, useRef } from 'react';
import { TestimonialsV5 } from 'types/studio/studio';
import styles from './styles.module.scss';
import TestimonialsSliderThumb from '../TestimonialsSliderThumb/TestimonialsSliderThumb';

type Props = {
  cards: TestimonialsV5['cards'];
  onThumbClick: (index: number) => void;
  selectedSlide: number;
  visibleOnPageLoad: boolean;
} & Pick<TestimonialsV5, 'theme'>;

const TestimonialsSliderThumbs = ({
  cards,
  selectedSlide,
  onThumbClick,
  theme,
  visibleOnPageLoad
}: Props) => {
  const container = useRef<HTMLDivElement>(null);
  const thumb = useRef<HTMLDivElement>(null);

  useEffect(() => {
    container.current?.scrollTo({
      left: selectedSlide * thumb.current!.offsetWidth,
      behavior: 'smooth'
    });
  }, [selectedSlide]);

  return (
    <div ref={container} className={styles.thumbs}>
      <div className={styles.thumbsContent}>
        {cards &&
          cards.map(({ _key: key, image }, index) => (
            <TestimonialsSliderThumb
              ref={thumb}
              key={key}
              image={image}
              onClick={() => onThumbClick(index)}
              index={index}
              selectedSlide={selectedSlide}
              theme={theme}
              visibleOnPageLoad={visibleOnPageLoad}
            />
          ))}
      </div>
    </div>
  );
};
export default TestimonialsSliderThumbs;
